import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import LoadingContainer from './LoadingContainer';


ReactDOM.render(
  
    <LoadingContainer />
  ,
  document.getElementById('root')
);

